export default __webpack_public_path__ + "static/media/card-key.60f51e2d.svg";